import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { businessunitsActions } from '../../../actions/businessunitsActions'
import './BusinessUnitMultiSelect.scss'
import RequieredInputs from '../../common/RequiredInputs'
import { Form } from 'react-bootstrap'

const BusinessUnitMultiSelect = ({
  value = [],
  onChange,
  placeholder = 'Selecciona unidades de negocio...',
  label = 'Unidades de Negocio',
  required = false,
  disabled = false,
  size = '', // 'sm', 'md', 'lg', 'xl'
  compact = true, // Por defecto compacto para modales
}) => {
  const dispatch = useDispatch()
  const businessUnits = useSelector((state) => state.businessunits)
  const [isOpen, setIsOpen] = useState(false)
  const [isInModal, setIsInModal] = useState(false)

  // Cargar business units si no están cargadas
  useEffect(() => {
    if (!businessUnits || businessUnits.length === 0) {
      dispatch(businessunitsActions.getAllBusinessUnits())
    }
  }, [businessUnits, dispatch])

  // Detectar si está dentro de un modal
  useEffect(() => {
    const modalElement = document.querySelector('.custom-modal')
    setIsInModal(modalElement !== null)
  }, [])

  // Filtrar business units según el término de búsqueda
  const filteredBusinessUnits = businessUnits

  // Verificar si están todas seleccionadas
  const areAllSelected =
    businessUnits.length > 0 &&
    businessUnits.every((unit) => value.includes(unit.id_NegocioUnidad))

  // Manejar toggle de selección total
  const handleToggleAll = () => {
    if (areAllSelected) {
      onChange([]) // Deseleccionar todas
    } else {
      const allIds = businessUnits.map((unit) => unit.id_NegocioUnidad)
      onChange(allIds) // Seleccionar todas
    }
  }

  // Manejar selección/deselección de una business unit
  const handleToggleBusinessUnit = (unitId) => {
    const updatedValue = value.includes(unitId)
      ? value.filter((id) => id !== unitId)
      : [...value, unitId]

    onChange(updatedValue)
  }

  // Obtener nombres de las business units seleccionadas
  const getSelectedNames = () => {
    return businessUnits
      .filter((unit) => value.includes(unit.id_NegocioUnidad))
      .map((unit) => unit.nombre)
  }

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.business-unit-multiselect')) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const selectedNames = getSelectedNames()

  return (
    <div
      className={`business-unit-multiselect ${
        compact || isInModal ? 'compact' : ''
      }`}
    >
      {label && (
          <h4 className="filter__title">
            Unidades de Negocio {required && <RequieredInputs invert={false} />}
          </h4>
      )}

      <div className='business-unit-multiselect__container'>
        <div
          className={`business-unit-multiselect__trigger ${size} ${
            isOpen ? 'open' : ''
          } ${disabled ? 'disabled' : ''}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          <div className='business-unit-multiselect__display'>
            {selectedNames.length > 0 ? (
              <div className='business-unit-multiselect__selected'>
                {selectedNames.length === 1 ? (
                  selectedNames[0]
                ) : (
                  <span className='business-unit-multiselect__count'>
                    {selectedNames.length} unidades seleccionadas
                  </span>
                )}
              </div>
            ) : (
              <span className='business-unit-multiselect__placeholder'>
                {placeholder}
              </span>
            )}
          </div>
          <div className='business-unit-multiselect__arrow'>
            <svg
              width='12'
              height='8'
              viewBox='0 0 12 8'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M1 1.5L6 6.5L11 1.5'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
        </div>

        {isOpen && (
          <div className='business-unit-multiselect__dropdown'>
            <div className='business-unit-multiselect__actions'>
              <button
                type='button'
                onClick={handleToggleAll}
                className='business-unit-multiselect__action-btn'
                disabled={businessUnits.length === 0}
              >
                {areAllSelected ? 'Deseleccionar todo' : 'Seleccionar todo'}
              </button>
            </div>

            <div className='business-unit-multiselect__options'>
              {filteredBusinessUnits.length > 0 ? (
                filteredBusinessUnits.map((unit) => (
                  <div
                    key={unit.id_NegocioUnidad}
                    className='business-unit-multiselect__option'
                    onClick={() =>
                      handleToggleBusinessUnit(unit.id_NegocioUnidad)
                    }
                  >
                    <input
                      type='checkbox'
                      checked={value.includes(unit.id_NegocioUnidad)}
                      onChange={() => {}} // Controlado por onClick del div
                      className='business-unit-multiselect__checkbox'
                    />
                    <span className='business-unit-multiselect__option-text'>
                      {unit.nombre}
                    </span>
                  </div>
                ))
              ) : (
                <div className='business-unit-multiselect__no-options'>
                  No hay unidades de negocio disponibles
                </div>
              )}
            </div>

            {value.length > 0 && (
              <div className='business-unit-multiselect__footer'>
                <span className='business-unit-multiselect__selected-count'>
                  {value.length} de {businessUnits.length} seleccionadas
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default BusinessUnitMultiSelect
